import { useEffect, useState } from 'react';
import httpClient from '../../../../../../shared/libraries/httpClient';
import routes from '../../../../../../shared/routes';

const verificationHelper = (affiliateId) => {
  const VERIFICATION_STATUS = {
    unverified: 'unverified',
    verified: 'verified',
  };

  const [status, setStatus] = useState('verified');
  const [initialStatus, setInitialStatus] = useState('verified');
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAffiliateVerificationStatus = async () => {
    if (!affiliateId) return;

    try {
      const { data } = await httpClient.get(
        routes.affiliates.fetch({ id: affiliateId }),
      );
      const affiliate = data.affiliate;
      const fetchedStatus = affiliate.verified
        ? VERIFICATION_STATUS.verified
        : VERIFICATION_STATUS.unverified;

      setStatus(fetchedStatus);
      setInitialStatus(fetchedStatus);
    } catch (error) {
      setError(
        I18n.t('components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.errors.fetch')
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    setStatus(initialStatus);
    setIsEditing(false);
  };

  const handleSave = async () => {
    if (!affiliateId) return;

    setIsSaving(true);

    try {
      await httpClient.patch(routes.affiliates.update({ id: affiliateId }), {
        affiliate: {
          verified: status === VERIFICATION_STATUS.verified,
        },
      });

      setInitialStatus(status);
      setIsEditing(false);
    } catch (error) {
      setError(
        I18n.t('components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.errors.save')
      );
    } finally {
      setIsSaving(false);
    }
  };

  const handleStatusChange = (newStatus) => setStatus(newStatus);

  const handleClearError = () => setError(null);

  useEffect(() => {
    fetchAffiliateVerificationStatus();
  }, [affiliateId]);

  return {
    status,
    initialStatus,
    isEditing,
    isSaving,
    isLoading,
    error,
    handleEdit,
    handleCancel,
    handleSave,
    handleStatusChange,
    handleClearError,
  };
};

export default verificationHelper;
